<template>
  <div>
    <el-dialog title="新增分类" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
      :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
      style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);" @close="dialogClose" v-el-drag-dialog
      v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>基本信息</b>
            </div>
            <table class="table-detail">
              <tbody>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    名称:
                  </th>
                  <td>
                    <el-input size="medium" :maxlength="50" v-model="requestParam.categoryName" placeholder="名称" />
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    编码:
                  </th>
                  <td>
                    <el-input size="medium" @blur="inspection(requestParam.categoryCode, null)" :maxlength="10"
                        v-model="requestParam.categoryCode" placeholder="编码" />
                  </td>
                  <th>
                  类型:
                  </th>
                  <td>
                    <el-input size="medium" v-model="requestParam.categoryType" placeholder="" :readonly="true" />
                  </td>
                  <th>
                        <em class="f-red">*</em>
                        完工条码数:
                      </th>
                      <td>
                        <el-select v-model="requestParam.barcodeNumber">
                        <el-option :value="1" label="1" />
                        <el-option :value="2" label="2" />
                        <el-option :value="3" label="3" />
                      </el-select>
                      </td>


                  <!-- <th>
                  <em class="f-red">*</em>
                  是否默认地址
                </th>
                <td>
                  <el-select v-model="requestParam.isDefault" clearable>
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td> -->
                </tr>
                <tr>
                  <th>
                    识别标识:
                  </th>
                  <td>
                    <el-input size="medium" :maxlength="10" v-model="requestParam.idMark" placeholder="请输入" />
                  </td>
                  <th>
                    <em class="f-red">*</em>
                    是否图片质检:
                  </th>
                  <td>
                    <el-select v-model="requestParam.picCheckMark"  >
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                      </el-select>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    是否商城使用:
                  </th>
                  <td>
                    <el-select v-model="requestParam.saleUse"  >
                        <el-option label="否" :value="0" />
                        <el-option label="是" :value="1" />
                      </el-select>
                  </td>

                  <th>
                    <em class="f-red">*</em>
                    是否微信使用:
                  </th>
                  <td>
                    <el-select v-model="requestParam.isShowwx"  >
                      <el-option label="否" :value="0" />
                      <el-option label="是" :value="1" />
                    </el-select>
                  </td>

                </tr>

                <tr>
                  <th>
                    <em class="f-red">*</em>
                    启用:
                  </th>
                  <td>
                    <el-select v-model="requestParam.usable"  >
                      <el-option label="禁用" :value="0" />
                      <el-option label="启用" :value="1" />
                    </el-select>
                  </td>
                  <th>
                    排序:
                  </th>
                  <td>
                    <el-input-number min="0" max="10"   :controls="false"
                        v-model="requestParam.seq" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-item">
                <div class="title first">
                  <b>保修信息</b>
                  <el-button class="button-sty btn_zdy" type="primary"
                    @click="showStarLevelDialog2 = true; starLevelObj = null">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                </div>
                <vxe-table
                style="width: 95%; margin: 10px auto;"
                ref="xTable" :column-config="{ resizable: true }" :data="requestParam.guaranteePeriods"
                  :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-config="{ height: 36 }"
                  :row-style="{ fontSize: '12px', background: '#fff' }" :stripe="true" height="150" keep-source
                  show-overflow>
                  <vxe-column field="startDate" title="开始时间" width="110" />
                  <vxe-column field="endDate" title="结束时间" width="110" />
                  <vxe-column field="guaranteePeriodMonthes" title="保修期(按月)" width="110" />
                  <vxe-column field="warrantyPeriod" title="保修年限" width="110" />
                  <vxe-column field="othersDesc" title="其他" width="110" />

                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a class="a-link" href="javascript:void(0);" @click="editStarLevel(row)">
                        <el-tooltip content="编辑" effect="dark" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" plain class="button-sty" @click="dialogClose">
          <i class="el-icon-close el-icon"></i>
          取 消
        </el-button>
        <el-button type="primary" @click="commitData" class="button-sty">
          <i class="el-icon-check el-icon"></i>
          确 定
        </el-button>
      </span>
    </el-dialog>
    <!-- 星级 -->
    <starLevel v-if="showStarLevelDialog2" :starLevelObj="starLevelObj" :visiable.sync="showStarLevelDialog2" multi="true"
      @commitData="commitStarLevelData" />
  </div>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
// 星级
import starLevel from './starLevel.vue';
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'parentId'],
  mixins: [selectDialogMixins],
  components: { preconditionDialog, pager, orderDialog,starLevel, },

  created() {
    this.initSetting()
    this.requestParam.parentId = this.parentId;
  },

  watch: {},

  mounted() {
    /*this.loadDictData()*/
  },

  computed: {},

  data() {
    return {
      starLevelObj: null,

      categoryType: '产品',
      showStarLevelDialog2: false,

      areaValues: [],
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      area: {
        country: null,
        province: null,
        city: null,
        county: null,
        town: null,
      },
      areaOption: [],

      dataId: 0,


      requestParam: {
        parentId: null,
        categoryType: 1,
        guaranteePeriods:[],
        starLevelId: null,
        startLevel: null,
        startLevelName: null,
        beginDate:'',
        endDate:'',
        serviceIntervalMonths: 0,//保养周期(按月)
        // isNew: true
      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      addressTypeOption: [],

    };
  },


  methods: {
    commitStarLevelData(data) {
      console.log("data", data)
      let filter = this.requestParam.guaranteePeriods.filter(item => item.starLevelId !== data.starLevelId)
      filter.push(data)
      this.requestParam.guaranteePeriods = filter
      console.log("this.requestParam.snSiteStarLevelDTOS时间", this.requestParam.guaranteePeriods)
    },
    editStarLevel(row) {
      this.starLevelObj = row
      this.showStarLevelDialog2 = true
    },
    getLabel(){
      this.$nextTick(()=>{
        this.requestParam.startLevelName = this.$refs.selectLabel.selected.label;
      })
    },

    // 当前页面确认按钮逻辑
    commitData() {
      console.log("this.requestParam.categoryName", this.requestParam.categoryName)
      if (this.requestParam.categoryName == null || this.requestParam.categoryName === '') {
        this.$message.warning('名称不能为空')
        return
      }
      if (this.requestParam.categoryCode == null || this.requestParam.categoryCode === '') {
        this.$message.warning('编码不能为空')
        return
      }
      if (this.requestParam.barcodeNumber == null || this.requestParam.barcodeNumber === '') {
        this.$message.warning('完工条码数不能为空')
        return
      }
      if (this.requestParam.picCheckMark == null || this.requestParam.picCheckMark === '') {
        this.$message.warning('图片质检不能为空')
        return
      }
      if (this.requestParam.saleUse == null || this.requestParam.saleUse === '') {
        this.$message.warning('是否商城使用不能为空')
        return
      }
      if (this.requestParam.usable == null || this.requestParam.usable === '') {
        this.$message.warning('启用状态不能为空')
        return
      }
      if (this.requestParam.guaranteePeriods == null || this.requestParam.guaranteePeriods === '') {
        this.$message.warning('保修信息不能为空')
        return
      }
      console.log("保修信息-------",this.requestParam.guaranteePeriods)


      this.$mask.open()
      this.$http({
        url: '/basic/basItemCategory/save',
        method: 'post',
        data: this.requestParam
      }).then(res => {
        if (this.requestParam.parentId === '') {
          this.$refs.tree.treeData.push({
            dataId: res.data.data,
            name: this.requestParam.categoryName,
            leaf: false
          })
        } else {
          this.temp.resolve({
            dataId: res.data.data,
            name: this.requestParam.categoryName,
            leaf: this.temp.leaf
          })
        }
        // this.requestParam.categoryType = 1
        this.closeAddDialog()
        this.$message.success("保存成功！");
        this.reload()
        this.$mask.close()

      }).catch(() => {
        this.$message.success("保存成功！");
        this.$mask.close()
      });

      this.$emit('commitDataIndex', )
      this.dialogClose()

    },

    handleChange() {
      const areaNode = this.$refs["cascader"].getCheckedNodes();
      console.log('handleNode', areaNode)
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        if (areaNode[0].level == 1) {
          this.area.country = areaNode[0].label;
          this.area.province = null;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 2) {
          this.area.province = areaNode[0].label;
          this.area.city = null;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 3) {
          this.area.city = areaNode[0].label;
          this.area.county = null;
          this.area.town = null;
        } else if (areaNode[0].level == 4) {
          this.area.county = areaNode[0].label;
          this.area.town = null;
        } else if (areaNode[0].level == 5) {
          this.area.town = areaNode[0].label;
        }

      } else {
        this.requestParam.areaId = null
        this.area.country = null;
        this.area.province = null;
        this.area.city = null;
        this.area.county = null;
        this.area.town = null;
      }

      const panelRefs = this.$refs.cascader.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }

    },

    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: {
          parentId: node.value
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          console.log('childNodes', childNodes)
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          console.log(node.children, 'child')
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },
  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 8vw;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {
  width: 100% !important;
  width: 11vw !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba( 0, 196, 179, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -50px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>


